import Action from 'redux/helpers/createAction'
const name = 'keywordGrossing'

export const getDomainKeywordGrossing = Action(
  name + '/GET_DOMAIN_KEYWORD_GROSSING_DATA',
  (domainId, filters) => ({
    domainId,
    filters
  })
)

export const getDomainKeywordGrossingSuccess = Action(
  name + '/GET_DOMAIN_KEYWORD_GROSSING_DATA_SUCCESS',
  (grossing, id) => ({
    grossing,
    id
  })
)

export const getDomainKeywordGrossingFailure = Action(
  name + '/GET_DOMAIN_KEYWORD_GROSSING_DATA_FAILURE',
  error => ({
    error
  })
)

export const exportDomainKeywordGrosingExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_GROSING_DATA_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordGrosingCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_GROSING_DATA_CSV',
  domainId => ({
    domainId
  })
)
